import React, { useState, useEffect, useRef } from 'react'
import styledComponents from '../styles/Container-style'
import Select from 'react-select';
import DataContainerAreaChange from './DataContainerAreaChange';
import DataContainerArea from './DataContainerArea';
import DataContainer from './DataContainer';
import DataContainerSite from './DataContainerSite';

import Modal from 'react-modal';

import moment from 'moment';
import 'moment/locale/ko';
import { getMaxYearOption } from '../config/yearConfig';

const { CustomContainer, BottomInfoContainer, InfoTitle, SelectRowContainer, SelectYearContainer, DataVisualizeContainer, SelectStartYearContainer, SelectYearBetweenWord, DataVisualizeContainer02, DataVisualizeContainer03, DataVisualizeContainer04, DataVisualizeContainer06, DataContainerWrapper, DataInfoGraphicContainer, DataInfoGraphicContainer02, DataInfoTitle, DataInfoTitle02, DataInfoNumber, DataInfoNumber01, DataInfoNumber02, DataInfoNumber03, DataInfoDescription, DataInfoSource, Column, Row, RowFirstTab, RowThirdTab, RowThirdTabTitle, ColumnSecondTab, ColumnGap,
    InfoTitleInvestigation, ReturnIcon, CoreAreaBtnContainer,
    InvestigationTableAreaNameWrapper, RowTable, InvestigationLabNameWrapper, InvestigationTypeWrapper, ArrowDownWrapper, ArrowDownWrapper02, UnitContainer, UnitOne, FlexRow, ColumnInvestigationInfo, InvestigationAreaInfoContainer, ColumnInvestigationImageContainer } = styledComponents;

// 데이터 시각화 패널 컨테이너
const Container = (props) => {
    const { yearList, SelectedTabId, SelectedPrevYear, handleSelectPrevYear, isTable, LabName, TableAreaName, InvestigationType, menu, SelectedAreaInfo, handleReturnInvestigationMain, SelectedPrevYearAreaChange, ImageList } = props;
    const [SelectedNextYear, setSelectedNextYear] = useState({ value: 2024, label: '2024년' })

    const [NextYearList, setNextYearList] = useState([])

    const [AreaNumber, setAreaNumber] = useState(0);
    const [AreaPercent, setAreaPercent] = useState(0);
    const [AreaTotal, setAreaTotal] = useState(0)

    const [AreaChangeNumber, setAreaChangeNumber] = useState(0);
    const [AreaChangePercent, setAreaChangePercent] = useState(0);
    const [AreaChangePlus, setAreaChangePlus] = useState(true);

    const [isSelectedOne, setisSelectedOne] = useState(true);
    const [isSelectedTwo, setisSelectedTwo] = useState(false);
    const [isUnitOpen, setisUnitOpen] = useState(false);

    const [CoreAreaWidth, setCoreAreaWidth] = useState(getWindowDimensions()-267);
    // const [windowDimensions, setWindowDimensions] = useState();

    // const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    // const { data, error, isError, isLoading } = useQuery(['yearId', YearUrl], () => fetchYearData(YearUrl));

    // 해초대전용
    const sgYearList = [
        //{value: 2015, label: '2015년'},    
        {value: 2016, label: '2016년'},    
        {value: 2017, label: '2017년'},    
        {value: 2018, label: '2018년'},    
        {value: 2019, label: '2019년'},    
        {value: 2020, label: '2020년'},    
		{value: 2021, label: '2021년'},    
		{value: 2022, label: '2022년'},    
		{value: 2023, label: '2023년'},    
		{value: 2024, label: '2024년'},    
    ]

    const handleSelectNextYear = (year) => {
        setSelectedNextYear(year)
    }

    const handleAreaChangeNumber = (num, percent, numbers = true) => {
        if (numbers) {
            const number = num.toFixed(1)
            let percentNumb = Math.abs(percent.toFixed(2))
            if (percentNumb == Infinity || percentNumb == NaN) { percentNumb = ' - ' }
            setAreaChangeNumber(number)
            setAreaChangePercent(percentNumb)
            if (num < 0) {
                setAreaChangePlus(false)
            } else (
                setAreaChangePlus(true)
            )
        } else {
            setAreaChangeNumber(0)
            setAreaChangePercent('-')
        }
    }

    const handleAreaNumber = (num, total) => {
        if (!isNaN(num)) {
            const number = num//.toFixed(0)
            // const percentNumb = (num / total).toFixed(2)
            const percentNumb = ((num / total * 1) * 100).toPrecision(3) * 1
            const totalNumber = Math.round(total)
            // const localString = totalNumber.toLocaleString()
            setAreaTotal(totalNumber)
            setAreaNumber(number)
            setAreaPercent(percentNumb)
        } else {
            setAreaNumber(0)
            setAreaPercent(0)
        }
    }

    const handleUnitOpen = (index) => {
        setisUnitOpen(!isUnitOpen)
        if (index === 1) {
            setisSelectedOne(true)
            setisSelectedTwo(false)
            setAreaChangeNumber(AreaChangeNumber)
        } else if (index === 2) {
            setisSelectedOne(false)
            setisSelectedTwo(true)
        }
    }

    function getWindowDimensions() {
        const width = window.innerWidth;
        return width;
    }

    const stageCanvasRef1 = useRef(null);
    const stageCanvasRef2 = useRef(null);
    const stageCanvasRef3 = useRef(null);

    function handleResize() {
        // setCoreAreaWidth(getWindowDimensions());

        if (stageCanvasRef1.current) {
            let width = stageCanvasRef1.current.offsetWidth;
            setCoreAreaWidth(width);
            // console.log(stageCanvasRef.current, width, 'width')
        }
        if (stageCanvasRef2.current) {
            let width = stageCanvasRef2.current.offsetWidth;
            setCoreAreaWidth(width);
            // console.log(stageCanvasRef.current, width, 'width')
        }
        if (stageCanvasRef3.current) {
            let width = stageCanvasRef3.current.offsetWidth;
            setCoreAreaWidth(width);
            // console.log(stageCanvasRef.current, width, 'width')
        }
    }
    var _ = require('lodash');

    useEffect(() => {
        const throttledFunc = _.throttle(function () {
            handleResize();
        }, 2000);
        window.addEventListener('resize', throttledFunc);
        return () => window.removeEventListener('resize', throttledFunc);
    }, []);

    useEffect(() => {
        const nextYearList = yearList.filter(item => item.value > SelectedPrevYearAreaChange.value)
        setNextYearList(prevList => ([...nextYearList]))
        // console.log(yearList)
        // console.log(SelectedPrevYear)
    }, [SelectedPrevYearAreaChange, yearList])

    useEffect(() => {
        setSelectedNextYear(getMaxYearOption(menu));
    }, [menu])

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalImgSrc, setModalImgSrc] = useState('');

    const renderImage = ImageList.map((item, index) => {
        return (
            <a onClick={()=> {
                setModalImgSrc(item);
                setModalIsOpen(true);
            }} 
                key={index}
            >
                <img src={item} alt={""} width={187} height={153} key={index} />
            </a>
        )
    })

    const modalStyle = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 11,
        },
        content: {
            display: "flex",
            padding:0,
            justifyContent: "center",
            background: "transparent",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            border:0,
            borderRadius:0,
            outline: "none",
            zIndex: 10,
        },
    };

    // useEffect(() => {
    //     function handleResize() {
    //         setWindowDimensions(getWindowDimensions());
    //     }
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);

    return (
        <CustomContainer>

        <Modal 
    		isOpen={modalIsOpen}
			style={modalStyle}
			onRequestClose={() => setModalIsOpen(false)} // 오버레이나 esc를 누르면 핸들러 동작
			ariaHideApp={false}
            
    	>
            <img src={modalImgSrc} alt={""} />

            <CoreAreaBtnContainer onClick={()=> setModalIsOpen(false)} 
                style={{transform:" scale(2.5) translate(12px, 10px)", background:"white", border:"0"}}>
                <ReturnIcon style={{transform: "scale(1.5) translate(1.5px,0.5px)"}} alt="<-" src="./images/ReturnIcon.svg" />
            </CoreAreaBtnContainer>
    	</Modal>

            {menu === 0 &&
                <BottomInfoContainer>

                    {SelectedTabId === 0 &&
                        <>
                            <RowFirstTab>
                                <Column>
                                    {/* 면적 데이터 */}
                                    <Row>
                                        <InfoTitle>갯벌 면적</InfoTitle>
                                        <SelectRowContainer>
                                            {/* 연도 선택 */}
                                            <SelectYearContainer>
                                                <Select
                                                    defaultValue={yearList[0]}
                                                    options={yearList}
                                                    onChange={handleSelectPrevYear}
                                                    value={SelectedPrevYear}
                                                />
                                            </SelectYearContainer>
                                        </SelectRowContainer>
                                    </Row>
                                    {/* 면적 데이터 시각화 */}
                                    <DataVisualizeContainer04>
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataContainerArea
                                                menu={menu}
                                                menuKey={'11'}
                                                Color={'#AB5133'}
                                                SelectedPrevYear={SelectedPrevYear.value} SelectedAreaInfo={SelectedAreaInfo}
                                                yearList={yearList} handleAreaNumber={handleAreaNumber} />
                                        }
                                        {/* 면적 인포그래픽 */}
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataInfoGraphicContainer>
                                                <DataInfoTitle>
                                                    면적량
                                                </DataInfoTitle>
                                                {SelectedAreaInfo.SG &&
                                                    <>
                                                        <FlexRow>
                                                            <DataInfoNumber01>{SelectedPrevYear.value}<span style={{ marginRight: "8px" }}>{'년'}</span></DataInfoNumber01>
                                                            <DataInfoNumber02 >{SelectedAreaInfo.SG}
                                                            </DataInfoNumber02>
                                                            <DataInfoNumber03>
                                                                <span style={{ marginRight: "8px" }}>{'의 갯벌은'}</span>
                                                            </DataInfoNumber03>

                                                            <DataInfoNumber03>
                                                                {
                                                                    /*isSelectedOne ? (AreaNumber == "0" ? "-" : AreaNumber.toLocaleString()) : (AreaNumber * 100).toLocaleString()*/
                                                                    isSelectedOne ? (AreaNumber == "0" ? "0.0" : AreaNumber.toLocaleString()) : (AreaNumber * 100).toLocaleString()
                                                                }
                                                                {isSelectedOne ? <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span>
                                                                    :
                                                                    <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>
                                                                }
                                                                <span >{'로'}</span>
                                                                <ArrowDownWrapper02>
                                                                    <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                                    {isUnitOpen &&
                                                                        <UnitContainer >
                                                                            <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                            <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                                        </UnitContainer>
                                                                    }
                                                                </ArrowDownWrapper02>
                                                            </DataInfoNumber03>

                                                        </FlexRow>
                                                        <DataInfoDescription>
                                                            {SelectedPrevYear.label} 대한민국 갯벌 면적 {AreaTotal}㎢의 약 <span>{
                                                                /*(AreaPercent == "0" ? "-" : AreaPercent)*/
                                                                (AreaPercent == "0" ? "0" : AreaPercent)
                                                            }</span>% 입니다.
                                                        </DataInfoDescription>
                                                    </>
                                                }

                                                {!SelectedAreaInfo.SG &&
                                                    <>
                                                        <FlexRow>
                                                            <DataInfoNumber01>
                                                                {SelectedPrevYear.value}<span style={{ marginRight: "8px" }}>{'년'}</span>
                                                            </DataInfoNumber01>
                                                            <DataInfoNumber02 >대한민국<span style={{ marginLeft: "4px", marginRight: "8px" }}>{'갯벌 면적은'}</span>
                                                            </DataInfoNumber02>
                                                            <DataInfoNumber03>
                                                                {isSelectedOne ? (AreaTotal == "0" ? "-" : AreaTotal.toLocaleString()) : (AreaTotal * 100).toLocaleString()}
                                                                {isSelectedOne ? <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span>
                                                                    :
                                                                    <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>
                                                                }
                                                                <ArrowDownWrapper02>
                                                                    <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                                    {isUnitOpen &&
                                                                        <UnitContainer >
                                                                            <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                            <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                                        </UnitContainer>
                                                                    }
                                                                </ArrowDownWrapper02>
                                                                <span>입니다.</span>
                                                            </DataInfoNumber03>
                                                        </FlexRow>
                                                    </>
                                                }
                                            </DataInfoGraphicContainer>
                                        }

                                    </DataVisualizeContainer04>
                                    <DataInfoSource>
                                        출처 : 해양수산부 연안습지면적현황(국가승인통계)
                                    </DataInfoSource>

                                </Column>
                                <ColumnGap></ColumnGap>
                                <Column>
                                    {/* 면적변화량 데이터 | 조간대/갯벌 */}
                                    <Row>
                                        <InfoTitle>갯벌 면적변화</InfoTitle>
                                        <SelectRowContainer>
                                            {/* 연도 선택 | 조간대/갯벌  */}
                                            <SelectYearBetweenWord>from</SelectYearBetweenWord>
                                            <SelectStartYearContainer>
                                                <Select
                                                    defaultValue={yearList[0]}
                                                    options={yearList.filter(item => item.value < SelectedNextYear.value)}
                                                    value={SelectedPrevYearAreaChange}
                                                    onChange={handleSelectPrevYear}
                                                // onChange={getYearId}
                                                />
                                            </SelectStartYearContainer>
                                            <SelectYearBetweenWord>to</SelectYearBetweenWord>
                                            <SelectStartYearContainer>
                                                <Select
                                                    defaultValue={yearList[yearList.length - 1]}
                                                    options={NextYearList}
                                                    isDisabled={SelectedPrevYearAreaChange ? false : true}
                                                    onChange={handleSelectNextYear}
                                                />
                                            </SelectStartYearContainer>
                                        </SelectRowContainer>
                                    </Row>
                                    {/* 면적 변화량 데이터 시각화 | 조간대/갯벌  */}
                                    <DataVisualizeContainer02>
                                        {/* 면적 변화량 인포그래픽 | 조간대/갯벌  */}
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataInfoGraphicContainer02>
                                                <DataInfoTitle02 style={{minWidth:'200px'}}>
                                                    면적 변화량
                                                </DataInfoTitle02>
                                                { isNaN(AreaChangePercent) &&
                                                <DataInfoNumber style={{minHeight:'70px'}}>
                                                </DataInfoNumber>
                                                }
                                                { !isNaN(AreaChangePercent) && AreaChangePercent !== '-' &&
                                                <DataInfoNumber>
                                                    {AreaChangePlus ? '↑' : '↓'}
                                                    {isSelectedOne ? AreaChangeNumber.toLocaleString() : (AreaChangeNumber * 100).toLocaleString()}
                                                    {isSelectedOne ?
                                                        <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span> :
                                                        <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>}
                                                    <ArrowDownWrapper>
                                                        <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                        {isUnitOpen &&
                                                            <UnitContainer >
                                                                <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                            </UnitContainer>
                                                        }
                                                    </ArrowDownWrapper>
                                                </DataInfoNumber>
                                                }
                                                { !isNaN(AreaChangePercent) && AreaChangePercent !== '-' &&
                                                <DataInfoDescription>
                                                    <span>{isNaN(AreaChangePercent) ? '-' : AreaChangePercent}</span>% {AreaChangePlus ? '증가' : '감소'}했습니다.
                                                </DataInfoDescription>
                                                }
                                            </DataInfoGraphicContainer02>
                                        }

                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataContainerWrapper>
                                                <DataContainerAreaChange
                                                    menu={menu}
                                                    menuKey={'11'}
                                                    Color={'#AB5133'}
                                                    SelectedPrevYear={SelectedPrevYearAreaChange.value} SelectedNextYear={SelectedNextYear.value}
                                                    SelectedAreaInfo={SelectedAreaInfo} handleAreaChangeNumber={handleAreaChangeNumber} />
                                            </DataContainerWrapper>
                                        }

                                    </DataVisualizeContainer02>
                                </Column>
                            </RowFirstTab>
                        </>
                    }

                    {SelectedTabId === 1 &&
                        <>
                            <ColumnSecondTab>
                                {/* 이산화탄소 */}
                                <Row>
                                    <InfoTitle>갯벌 이산화탄소 흡수량</InfoTitle>
                                    <SelectRowContainer>
                                        {/* 연도 선택 */}
                                        <SelectYearContainer>
                                            <Select
                                                defaultValue={yearList[0]}
                                                options={yearList}
                                                value={SelectedPrevYear}
                                                onChange={handleSelectPrevYear}
                                            />
                                        </SelectYearContainer>
                                    </SelectRowContainer>
                                </Row>
                                {/* 이산화탄소 시각화 */}
                                <DataVisualizeContainer>
                                    {/* <DataContainer /> */}
                                </DataVisualizeContainer>
                            </ColumnSecondTab>
                        </>
                    }

                    {SelectedTabId === 2 &&
                        <>
                            {!isTable &&
                                <Column>
                                    {/* 현장조사 핵심지역 탄소저장량 */}
                                    <RowThirdTab>
                                        <InfoTitle>핵심지역의 토양유기탄소저장량 (Mg C ha ⁻ ¹)</InfoTitle>
                                    </RowThirdTab>
                                    {/* 현장조사 핵심지역 탄소저장량 시각화 */}
                                    <DataVisualizeContainer03 ref={stageCanvasRef1}>
                                        <DataContainer
                                            menu={menu}
                                            statKey={'sediment'}
                                            Color={'#AB5133'}
                                            CoreAreaWidth={CoreAreaWidth}
                                        />
                                    </DataVisualizeContainer03>
                                </Column>
                            }

                            {/* 지역별 정보 */}
                            {isTable &&
                                <>
                                    <Column>
                                        {/* 현장조사 핵심지역 탄소저장량 */}
                                        <RowThirdTabTitle>
                                            <InfoTitleInvestigation>현장조사 지역정보</InfoTitleInvestigation>
                                        </RowThirdTabTitle>
                                        {/* 현장조사 핵심지역 탄소저장량 시각화 */}
                                        {TableAreaName && TableAreaName !== '' &&
                                            <InvestigationAreaInfoContainer>
                                                {/* <DataContainer /> */}
                                                <>
                                                    <ColumnInvestigationInfo>
                                                        <InvestigationTableAreaNameWrapper>{TableAreaName}</InvestigationTableAreaNameWrapper>
                                                        <RowTable>
                                                            <InvestigationTypeWrapper>
                                                                조사항목
                                                            </InvestigationTypeWrapper>
                                                            {InvestigationType && InvestigationType !== undefined &&
                                                                <>
                                                                    <InvestigationLabNameWrapper>{InvestigationType}</InvestigationLabNameWrapper>
                                                                </>
                                                            }

                                                        </RowTable>

                                                        <RowTable>
                                                            <InvestigationTypeWrapper>
                                                                조사기관
                                                            </InvestigationTypeWrapper>
                                                            {LabName && LabName !== undefined &&
                                                                <>
                                                                    <InvestigationLabNameWrapper>{LabName}</InvestigationLabNameWrapper>
                                                                </>
                                                            }
                                                        </RowTable>
                                                    </ColumnInvestigationInfo>
                                                    <ColumnInvestigationImageContainer>
                                                        {ImageList[0] !== undefined &&
                                                            <>
                                                                {renderImage}
                                                            </>
                                                        }
                                                    </ColumnInvestigationImageContainer>
                                                </>

                                            </InvestigationAreaInfoContainer>
                                        }

                                    </Column>
                                    <ColumnGap></ColumnGap>
                                    <Column>
                                        <RowThirdTabTitle>
                                            <InfoTitleInvestigation>현장조사 지역 토양유기탄소저장량</InfoTitleInvestigation>
                                            <SelectRowContainer>
                                                <CoreAreaBtnContainer
                                                    onClick={handleReturnInvestigationMain}>
                                                    <ReturnIcon alt="<-" src="./images/ReturnIcon.svg" />
                                                    핵심지역
                                                </CoreAreaBtnContainer>
                                            </SelectRowContainer>
                                        </RowThirdTabTitle>
                                        {TableAreaName && TableAreaName !== '' &&
                                            <DataVisualizeContainer06>
                                                
                                                <DataContainerSite
                                                    InvestigationType={InvestigationType}
                                                    menu={menu}
                                                    Color={'#AB5133'}
                                                    TableAreaName={TableAreaName}
                                                />
                                            </DataVisualizeContainer06>
                                        }

                                    </Column>
                                </>
                            }
                        </>
                    }
                </BottomInfoContainer>
            }
            {menu === 1 &&
                <BottomInfoContainer>
                    {SelectedTabId === 0 &&
                        <>
                            <RowFirstTab>
                                <Column>
                                    {/* 면적 데이터 */}
                                    <Row>
                                        <InfoTitle>해초대 면적</InfoTitle>
                                        <SelectRowContainer>
                                            <SelectYearContainer>
                                                <Select
                                                    defaultValue={sgYearList[0]}
                                                    options={sgYearList}
                                                    onChange={handleSelectPrevYear}
                                                    value={SelectedPrevYear}
                                                />
                                            </SelectYearContainer>
                                        </SelectRowContainer>

                                    </Row>

                                    {/* 면적 데이터 시각화 */}
                                    <DataVisualizeContainer04>
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataContainerArea
                                                menu={menu}
                                                menuKey={'12'}
                                                Color={'#005DCB'}
                                                SelectedPrevYear={SelectedPrevYear.value} SelectedAreaInfo={SelectedAreaInfo}
                                                yearList={yearList} handleAreaNumber={handleAreaNumber} />
                                        }
                                        <DataInfoGraphicContainer>
                                            <DataInfoTitle>
                                                면적량
                                            </DataInfoTitle>
                                            {SelectedAreaInfo.SG &&
                                                <>
                                                    <FlexRow>
                                                        <DataInfoNumber01>{SelectedPrevYear.value}<span style={{ marginRight: "8px" }}>{'년'}</span></DataInfoNumber01>
                                                        <DataInfoNumber02 >{SelectedAreaInfo.SG}
                                                        </DataInfoNumber02>
                                                        <DataInfoNumber03><span style={{ marginRight: "8px" }}>{'의 해초대는'}</span>
                                                        </DataInfoNumber03>
                                                        <DataInfoNumber03>
                                                            {
                                                                /*isSelectedOne ? (AreaNumber == "0" ? "-" : AreaNumber) : AreaNumber * 100*/
                                                                isSelectedOne ? (AreaNumber == "0" ? "0.0" : AreaNumber.toLocaleString()) : (AreaNumber * 100).toLocaleString()
                                                            }
                                                            {/*AreaNumber*/}
                                                            {isSelectedOne ? <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span>
                                                                :
                                                                <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>
                                                            }
                                                            <span >{'로'}</span>
                                                            <ArrowDownWrapper02>
                                                                <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                                {isUnitOpen &&
                                                                    <UnitContainer >
                                                                        <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                        <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                                    </UnitContainer>
                                                                }
                                                            </ArrowDownWrapper02>
                                                        </DataInfoNumber03>
                                                    </FlexRow>
                                                    <DataInfoDescription>
                                                        {SelectedPrevYear.label} 대한민국 해초대 면적 {AreaTotal}㎢의 약 <span>{
                                                            /*(AreaPercent == "0" ? "-" : AreaPercent)*/
                                                            (AreaPercent == "0" ? "0" : AreaPercent)
                                                        }</span>% 입니다.
                                                    </DataInfoDescription>
                                                </>
                                            }

                                            {!SelectedAreaInfo.SG &&
                                                <>
                                                    <FlexRow>
                                                        <DataInfoNumber01>
                                                            {SelectedPrevYear.value}<span style={{ marginRight: "8px" }}>{'년'}</span>
                                                        </DataInfoNumber01>
                                                        <DataInfoNumber02 >대한민국<span style={{ marginLeft: "4px", marginRight: "8px" }}>{'해초대 면적은'}</span>
                                                        </DataInfoNumber02>

                                                        <DataInfoNumber03>
                                                            {isSelectedOne ? (AreaTotal == "0" ? "-" : AreaTotal.toLocaleString()) : (AreaTotal * 100).toLocaleString()}
                                                            {isSelectedOne ? <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span>
                                                                :
                                                                <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>
                                                            }
                                                            <ArrowDownWrapper02>
                                                                <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                                {isUnitOpen &&
                                                                    <UnitContainer >
                                                                        <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                        <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                                    </UnitContainer>
                                                                }
                                                            </ArrowDownWrapper02>
                                                            <span>입니다.</span>
                                                        </DataInfoNumber03>
                                                    </FlexRow>
                                                </>
                                            }
                                        </DataInfoGraphicContainer>
                                    </DataVisualizeContainer04>
                                    <DataInfoSource>
                                        출처 : 해양수산부 연안습지면적현황(국가승인통계)
                                    </DataInfoSource>

                                </Column>
                                <ColumnGap></ColumnGap>
                                <Column>
                                    {/* 면적변화량 데이터 */}
                                    <Row>
                                        <InfoTitle>해초대 면적변화</InfoTitle>
                                        <SelectRowContainer>
                                            <SelectYearBetweenWord>from</SelectYearBetweenWord>
                                            <SelectStartYearContainer>
                                                <Select
                                                    defaultValue={sgYearList[0]}
                                                    options={sgYearList.filter(item => item.value < SelectedNextYear.value)}
                                                    value={SelectedPrevYearAreaChange}
                                                    onChange={handleSelectPrevYear}
                                                />
                                            </SelectStartYearContainer>
                                            <SelectYearBetweenWord>to</SelectYearBetweenWord>
                                            <SelectStartYearContainer>
                                                <Select
                                                    defaultValue={sgYearList[sgYearList.length - 1]}
                                                    options={NextYearList}
                                                    isDisabled={SelectedPrevYearAreaChange ? false : true}
                                                    onChange={handleSelectNextYear}
                                                />
                                            </SelectStartYearContainer>
                                        </SelectRowContainer>
                                    </Row>
                                    {/* 면적 변화량 데이터 시각화 */}
                                    <DataVisualizeContainer02>
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataInfoGraphicContainer02>
                                                <DataInfoTitle02 style={{minWidth:'200px'}}>
                                                    면적 변화량
                                                </DataInfoTitle02>
                                                { isNaN(AreaChangePercent) &&
                                                <DataInfoNumber style={{minHeight:'70px'}}>
                                                </DataInfoNumber>
                                                }
                                               { !isNaN(AreaChangePercent) && AreaChangePercent !== '-' &&
                                                <DataInfoNumber>
                                                    {AreaChangePlus ? '↑' : '↓'}
                                                    {isSelectedOne ? AreaChangeNumber : AreaChangeNumber * 100}
                                                    {isSelectedOne ?
                                                        <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span> :
                                                        <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>}
                                                    <ArrowDownWrapper>
                                                        <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                        {isUnitOpen &&
                                                            <UnitContainer >
                                                                <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                            </UnitContainer>
                                                        }
                                                    </ArrowDownWrapper>
                                                </DataInfoNumber>
                                                }

                                                { !isNaN(AreaChangePercent) && AreaChangePercent !== '-' &&
                                                <DataInfoDescription>
                                                    <span>{isNaN(AreaChangePercent) ? '-' : AreaChangePercent}</span>% {AreaChangePlus ? '증가' : '감소'}했습니다.
                                                </DataInfoDescription>
                                                }
                                            </DataInfoGraphicContainer02>
                                        }
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataContainerWrapper>
                                                <DataContainerAreaChange
                                                    menu={menu}
                                                    menuKey={'12'}
                                                    Color={'#005DCB'}
                                                    SelectedPrevYear={SelectedPrevYearAreaChange.value} SelectedNextYear={SelectedNextYear.value}
                                                    SelectedAreaInfo={SelectedAreaInfo} handleAreaChangeNumber={handleAreaChangeNumber} />
                                            </DataContainerWrapper>
                                        }

                                    </DataVisualizeContainer02>
                                </Column>
                            </RowFirstTab>
                        </>
                    }

                    {SelectedTabId === 1 &&
                        <>
                            <ColumnSecondTab>
                                {/* 이산화탄소 */}
                                <Row>
                                    <InfoTitle>해초대 이산화탄소 흡수량</InfoTitle>
                                    <SelectRowContainer>
                                        {/* 연도 선택 */}
                                        <SelectYearContainer>
                                            <Select
                                                defaultValue={yearList[0]}
                                                options={yearList}
                                                value={SelectedPrevYear}
                                                onChange={handleSelectPrevYear}
                                            />
                                        </SelectYearContainer>
                                    </SelectRowContainer>
                                </Row>
                                {/* 이산화탄소 시각화 */}
                                <DataVisualizeContainer>
                                    {/* <DataContainer /> */}
                                </DataVisualizeContainer>
                            </ColumnSecondTab>
                        </>
                    }

                    {SelectedTabId === 2 &&
                        <>
                            {!isTable &&
                                <Column>
                                    {/* 현장조사 핵심지역 탄소저장량 | 염습지 */}
                                    <RowThirdTab>
                                        <InfoTitle>핵심지역 해초대의 토양유기탄소함량 (%)</InfoTitle>
                                    </RowThirdTab>
                                    {/* 현장조사 핵심지역 탄소저장량 시각화 | 염습지 */}
                                    <DataVisualizeContainer03 ref={stageCanvasRef2}>
                                        <DataContainer
                                            menu={menu}
                                            statKey={'seagress'}
                                            Color={'#005DCB'}
                                            CoreAreaWidth={CoreAreaWidth}
                                        />
                                    </DataVisualizeContainer03>
                                </Column>
                            }

                            {/* 지역별 정보 */}
                            {isTable &&
                                <>
                                    <Column>
                                        {/* 현장조사 핵심지역 탄소저장량 | 염습지 */}
                                        <RowThirdTabTitle>
                                            <InfoTitleInvestigation>현장조사 지역정보</InfoTitleInvestigation>
                                        </RowThirdTabTitle>
                                        {/* 현장조사 핵심지역 탄소저장량 시각화 | 염습지 */}
                                        {TableAreaName && TableAreaName !== undefined &&
                                            <InvestigationAreaInfoContainer>
                                                {/* <DataContainer /> */}
                                                <>
                                                    <ColumnInvestigationInfo>
                                                        <InvestigationTableAreaNameWrapper>{TableAreaName}</InvestigationTableAreaNameWrapper>
                                                        <RowTable>
                                                            <InvestigationTypeWrapper>
                                                                조사항목
                                                            </InvestigationTypeWrapper>
                                                            {InvestigationType && InvestigationType !== undefined &&
                                                                <>
                                                                    <InvestigationLabNameWrapper>{InvestigationType}</InvestigationLabNameWrapper>
                                                                </>
                                                            }

                                                        </RowTable>

                                                        <RowTable>
                                                            <InvestigationTypeWrapper>
                                                                조사기관
                                                            </InvestigationTypeWrapper>
                                                            {LabName && LabName !== undefined &&
                                                                <>
                                                                    <InvestigationLabNameWrapper>{LabName}</InvestigationLabNameWrapper>
                                                                </>
                                                            }
                                                        </RowTable>
                                                    </ColumnInvestigationInfo>
                                                    <ColumnInvestigationImageContainer>
                                                        {ImageList[0] &&
                                                            <>
                                                                {renderImage}
                                                            </>
                                                        }
                                                    </ColumnInvestigationImageContainer>
                                                </>

                                            </InvestigationAreaInfoContainer>
                                        }
                                    </Column>
                                    <ColumnGap></ColumnGap>
                                    <Column>
                                        <RowThirdTabTitle>
                                            <InfoTitleInvestigation>현장조사 지역 토양유기탄소함량</InfoTitleInvestigation>
                                            <SelectRowContainer>
                                                <CoreAreaBtnContainer
                                                    onClick={handleReturnInvestigationMain}>
                                                    <ReturnIcon alt="<-" src="./images/ReturnIcon.svg" />
                                                    핵심지역
                                                </CoreAreaBtnContainer>
                                            </SelectRowContainer>
                                        </RowThirdTabTitle>
                                        {TableAreaName && TableAreaName !== '' &&
                                            <DataVisualizeContainer06>
                                                <DataContainerSite
                                                    InvestigationType={InvestigationType}
                                                    menu={menu}
                                                    Color={'#AB5133'}
                                                    TableAreaName={TableAreaName}
                                                />
                                            </DataVisualizeContainer06>
                                        }
                                    </Column>
                                </>
                            }
                        </>
                    }
                </BottomInfoContainer>
            }

            {menu === 2 &&
                <BottomInfoContainer>

                    {SelectedTabId === 0 &&
                        <>
                            <RowFirstTab>
                                <Column>
                                    {/* 면적 데이터 | 염습지 */}
                                    <Row>
                                        <InfoTitle>염습지 서식지 면적</InfoTitle>
                                        <SelectRowContainer>
                                            {/* 연도 선택 | 염습지 */}
                                            <SelectYearContainer>
                                                <Select
                                                    defaultValue={yearList[0]}
                                                    options={yearList}
                                                    onChange={handleSelectPrevYear}
                                                    value={SelectedPrevYear}
                                                />
                                            </SelectYearContainer>
                                        </SelectRowContainer>
                                    </Row>
                                    {/* 면적 데이터 시각화 | 염습지 */}
                                    <DataVisualizeContainer04>
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataContainerArea
                                                menu={menu}
                                                menuKey={'13'}
                                                Color={'#328400'}
                                                SelectedPrevYear={SelectedPrevYear.value} SelectedAreaInfo={SelectedAreaInfo}
                                                yearList={yearList} handleAreaNumber={handleAreaNumber} />
                                        }
                                        {/* 면적 인포그래픽 | 염습지 */}
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataInfoGraphicContainer>
                                                <DataInfoTitle>
                                                    면적량
                                                </DataInfoTitle>
                                                {SelectedAreaInfo.SG &&
                                                    <>
                                                        <FlexRow>
                                                            <DataInfoNumber01>{SelectedPrevYear.value}<span style={{ marginRight: "8px" }}>{'년'}</span></DataInfoNumber01>
                                                            <DataInfoNumber02 >{SelectedAreaInfo.SG}
                                                            </DataInfoNumber02>
                                                            <DataInfoNumber03><span style={{ marginRight: "8px" }}>{'의 염습지는'}</span>
                                                            </DataInfoNumber03>
                                                            <DataInfoNumber03>
                                                                {
                                                                    /*isSelectedOne ? (AreaNumber == "0" ? "-" : AreaNumber.toLocaleString()) : (AreaNumber * 100).toLocaleString()*/
                                                                    isSelectedOne ? (AreaNumber == "0" ? "0.0" : AreaNumber.toLocaleString()) : (AreaNumber * 100).toLocaleString()
                                                                }
                                                                {isSelectedOne ? <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span>
                                                                    :
                                                                    <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>
                                                                }
                                                                <span >{'로'}</span>
                                                                <ArrowDownWrapper02>
                                                                    <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                                    {isUnitOpen &&
                                                                        <UnitContainer >
                                                                            <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                            <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                                        </UnitContainer>
                                                                    }
                                                                </ArrowDownWrapper02>
                                                            </DataInfoNumber03>
                                                        </FlexRow>
                                                        <DataInfoDescription>
                                                            {SelectedPrevYear.label} 대한민국 염습지 서식지 면적 {AreaTotal}㎢의 약 <span>{
                                                                /*(AreaPercent == "0" ? "-" : AreaPercent)*/
                                                                (AreaPercent == "0" ? "0" : AreaPercent)
                                                            }</span>% 입니다.
                                                        </DataInfoDescription>
                                                    </>
                                                }
                                                {!SelectedAreaInfo.SG &&
                                                    <>
                                                        <FlexRow>
                                                            <DataInfoNumber01>
                                                                {SelectedPrevYear.value}<span style={{ marginRight: "8px" }}>{'년'}</span>
                                                            </DataInfoNumber01>
                                                            <DataInfoNumber02 >대한민국<span style={{ marginLeft: "4px", marginRight: "8px" }}>{'염습지 서식지 면적은'}</span>
                                                            </DataInfoNumber02>
                                                            <DataInfoNumber03>
                                                                {isSelectedOne ? (AreaTotal == "0" ? "-" : AreaTotal.toLocaleString()) : (AreaTotal * 100).toLocaleString()}
                                                                {isSelectedOne ? <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span>
                                                                    :
                                                                    <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>
                                                                }
                                                                <ArrowDownWrapper02>
                                                                    <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                                    {isUnitOpen &&
                                                                        <UnitContainer >
                                                                            <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                                            <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                                        </UnitContainer>
                                                                    }
                                                                </ArrowDownWrapper02>
                                                                <span>입니다.</span>
                                                            </DataInfoNumber03>

                                                        </FlexRow>
                                                    </>
                                                }

                                            </DataInfoGraphicContainer>
                                        }
                                    </DataVisualizeContainer04>
                                    <DataInfoSource>
                                        출처 : 해양수산부 국가 블루카본 온실가스 인벤토리 구축사업
                                    </DataInfoSource>

                                </Column>
                                <ColumnGap></ColumnGap>
                                <Column>
                                    {/* 면적변화량 데이터 */}
                                    <Row>
                                        <InfoTitle>염습지 서식지 면적변화</InfoTitle>
                                        <SelectRowContainer>
                                            {/* 연도 선택 */}
                                            <SelectYearBetweenWord>from</SelectYearBetweenWord>
                                            <SelectStartYearContainer>
                                                <Select
                                                    defaultValue={yearList[0]}
                                                    options={yearList.filter(item => item.value < SelectedNextYear.value)}
                                                    value={SelectedPrevYearAreaChange}
                                                    onChange={handleSelectPrevYear}
                                                // onChange={getYearId}
                                                />
                                            </SelectStartYearContainer>
                                            <SelectYearBetweenWord>to</SelectYearBetweenWord>
                                            <SelectStartYearContainer>
                                                <Select
                                                    defaultValue={yearList[yearList.length - 1]}
                                                    options={NextYearList}
                                                    isDisabled={SelectedPrevYearAreaChange ? false : true}
                                                    onChange={handleSelectNextYear}
                                                />
                                            </SelectStartYearContainer>
                                        </SelectRowContainer>
                                    </Row>
                                    {/* 면적 변화량 데이터 시각화 | 염습지 */}
                                    <DataVisualizeContainer02>
                                        {/* 면적 변화량 인포그래픽 | 염습지 */}
                                        <DataInfoGraphicContainer02>
                                            <DataInfoTitle02 style={{minWidth:'200px'}}>
                                                면적 변화량
                                            </DataInfoTitle02>
                                            { isNaN(AreaChangePercent) &&
                                            <DataInfoNumber style={{minHeight:'70px'}}>
                                            </DataInfoNumber>
                                            }
                                            { !isNaN(AreaChangePercent) && AreaChangePercent !== '-' &&
                                            <DataInfoNumber>
                                                {AreaChangePlus ? '↑' : '↓'}
                                                {isSelectedOne ? AreaChangeNumber.toLocaleString() : (AreaChangeNumber * 100).toLocaleString()}
                                                {isSelectedOne ?
                                                    <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'㎢'}</span> :
                                                    <span style={{ fontSize: "25px", fontWeight: "bold" }}>{'ha'}</span>}
                                                <ArrowDownWrapper>
                                                    <img src="./images/dropdownIcon.svg" alt="v" onClick={handleUnitOpen}></img>

                                                    {isUnitOpen &&
                                                        <UnitContainer >
                                                            <UnitOne selected={isSelectedOne} onClick={() => handleUnitOpen(1)}>㎢</UnitOne>
                                                            <UnitOne selected={isSelectedTwo} onClick={() => handleUnitOpen(2)}>ha</UnitOne>
                                                        </UnitContainer>
                                                    }
                                                </ArrowDownWrapper>
                                            </DataInfoNumber>
                                            }
                                            { !isNaN(AreaChangePercent) && AreaChangePercent !== '-' &&
                                            <DataInfoDescription>
                                                <span>{isNaN(AreaChangePercent) ? '-' : AreaChangePercent}</span>% {AreaChangePlus ? '증가' : '감소'}했습니다.
                                            </DataInfoDescription>
                                            }
                                        </DataInfoGraphicContainer02>
                                        {SelectedAreaInfo.SG !== undefined &&
                                            <DataContainerWrapper>
                                                <DataContainerAreaChange
                                                    menu={menu}
                                                    menuKey={'13'}
                                                    Color={'#328400'}
                                                    SelectedPrevYear={SelectedPrevYearAreaChange.value} SelectedNextYear={SelectedNextYear.value}
                                                    SelectedAreaInfo={SelectedAreaInfo} handleAreaChangeNumber={handleAreaChangeNumber} />
                                            </DataContainerWrapper>
                                        }

                                    </DataVisualizeContainer02>
                                </Column>
                            </RowFirstTab>
                        </>
                    }

                    {SelectedTabId === 1 &&
                        <>
                            <ColumnSecondTab>
                                {/* 이산화탄소 */}
                                <Row>
                                    <InfoTitle>염습지 이산화탄소 흡수량</InfoTitle>
                                    <SelectRowContainer>
                                        {/* 연도 선택 */}
                                        <SelectYearContainer>
                                            <Select
                                                defaultValue={yearList[0]}
                                                options={yearList}
                                                value={SelectedPrevYear}
                                                onChange={handleSelectPrevYear}
                                            />
                                        </SelectYearContainer>
                                    </SelectRowContainer>
                                </Row>
                                {/* 이산화탄소 시각화 */}
                                <DataVisualizeContainer>
                                    {/* <DataContainer /> */}
                                </DataVisualizeContainer>
                            </ColumnSecondTab>
                        </>
                    }

                    {SelectedTabId === 2 &&
                        <>
                            {!isTable &&
                                <Column>
                                    {/* 현장조사 핵심지역 탄소저장량 */}
                                    <RowThirdTab>
                                        <InfoTitle>핵심지역 염습지 서식지의 토양유기탄소농도 (%)</InfoTitle>
                                    </RowThirdTab>
                                    {/* 현장조사 핵심지역 탄소저장량 시각화 */}
                                    <DataVisualizeContainer03 ref={stageCanvasRef3}>
                                        <DataContainer
                                            menu={menu}
                                            statKey={'saltplant'}
                                            Color={'#328400'}
                                            CoreAreaWidth={CoreAreaWidth}
                                        />
                                    </DataVisualizeContainer03>
                                </Column>
                            }

                            {/* 지역별 정보 */}
                            {isTable &&
                                <>
                                    <Column>
                                        {/* 현장조사 핵심지역 탄소저장량 */}
                                        <RowThirdTabTitle>
                                            <InfoTitleInvestigation>현장조사 지역정보</InfoTitleInvestigation>
                                        </RowThirdTabTitle>
                                        {/* 현장조사 핵심지역 탄소저장량 시각화 */}
                                        {TableAreaName && TableAreaName !== undefined &&
                                            <InvestigationAreaInfoContainer>
                                                {/* <DataContainer /> */}
                                                <>
                                                    <ColumnInvestigationInfo>
                                                        <InvestigationTableAreaNameWrapper>{TableAreaName}</InvestigationTableAreaNameWrapper>
                                                        <RowTable>
                                                            <InvestigationTypeWrapper>
                                                                조사항목
                                                            </InvestigationTypeWrapper>
                                                            {InvestigationType && InvestigationType !== undefined &&
                                                                <>
                                                                    <InvestigationLabNameWrapper>{InvestigationType}</InvestigationLabNameWrapper>
                                                                </>
                                                            }

                                                        </RowTable>

                                                        <RowTable>
                                                            <InvestigationTypeWrapper>
                                                                조사기관
                                                            </InvestigationTypeWrapper>
                                                            {LabName && LabName !== undefined &&
                                                                <>
                                                                    <InvestigationLabNameWrapper>{LabName}</InvestigationLabNameWrapper>
                                                                </>
                                                            }
                                                        </RowTable>
                                                    </ColumnInvestigationInfo>
                                                    <ColumnInvestigationImageContainer>
                                                        {ImageList[0] &&
                                                            <>
                                                                {renderImage}
                                                            </>
                                                        }
                                                    </ColumnInvestigationImageContainer>
                                                </>

                                            </InvestigationAreaInfoContainer>
                                        }
                                    </Column>
                                    <ColumnGap></ColumnGap>
                                    <Column>
                                        <RowThirdTabTitle>
                                            <InfoTitleInvestigation>현장조사 지역 토양유기탄소농도</InfoTitleInvestigation>
                                            <SelectRowContainer>
                                                <CoreAreaBtnContainer
                                                    onClick={handleReturnInvestigationMain}>
                                                    <ReturnIcon alt="<-" src="./images/ReturnIcon.svg" />
                                                    핵심지역
                                                </CoreAreaBtnContainer>
                                            </SelectRowContainer>
                                        </RowThirdTabTitle>
                                        {TableAreaName && TableAreaName !== '' &&
                                            <DataVisualizeContainer06>
                                                <DataContainerSite
                                                    InvestigationType={InvestigationType}
                                                    menu={menu}
                                                    Color={'#AB5133'}
                                                    TableAreaName={TableAreaName}
                                                />
                                            </DataVisualizeContainer06>
                                        }
                                    </Column>
                                </>
                            }
                        </>
                    }
                </BottomInfoContainer>
            }
        </CustomContainer>
    )
};

export default Container;
